import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pictures/logo.svg")